import { CancelEnrolmentParams } from '../../../types/hubInterfaces';
import ChangePlanConfirmation from './ChangePlanConfirmation';
import ChangePlanSuccess from './ChangePlanSuccess';
import ChangePricingPlanPage from './ChangePricingPlanPage';
import TransitionDisabled from './TransitionDisabled';
import useChangePricingPlanContext, {
  ChangePricingPlanContextProvider,
  ChangePricingPlanSteps,
} from './useChangePricingPlanContext';

interface Props {
  interrupting?: boolean;
  cancelEnrolmentPayload?: CancelEnrolmentParams & {
    onSubmitSuccess(): void;
    onSubmitFailed?(): void;
  };
  onGoBack(): void;
}

export const ChangePricingPlanBase = ({ interrupting, cancelEnrolmentPayload, onGoBack }: Props) => {
  const { currentStep } = useChangePricingPlanContext();

  switch (currentStep) {
    case ChangePricingPlanSteps.CONFIRM_CHANGES:
      return <ChangePlanConfirmation />;
    case ChangePricingPlanSteps.CHANGES_SUCCESS:
      return <ChangePlanSuccess />;
    case ChangePricingPlanSteps.TRANSITION_DISABLED:
      return <TransitionDisabled />;
    case ChangePricingPlanSteps.CHOOSE_A_PLAN:
    default:
      return (
        <ChangePricingPlanPage
          interrupting={interrupting}
          cancelEnrolmentPayload={cancelEnrolmentPayload}
          onGoBack={onGoBack}
        />
      );
  }
};

const ChangePricingPlan = (props: Props) => {
  return (
    <ChangePricingPlanContextProvider>
      <ChangePricingPlanBase {...props} />
    </ChangePricingPlanContextProvider>
  );
};

export default ChangePricingPlan;
